import { useEffect, useState } from 'react';
import { useModalsContext } from '../../../../../../../../../../providers/ModalsProvider/Modals.context.ts';
import { useWorkspaceContext } from '../../../../../../../../../../providers/WorkspaceProvider/Workspace.context.ts';
import useChatActions from '../../../../../../../../Chat.actions.ts';
import { ChatEnum } from '../../../../../../../../Chat.enum.ts';
import { useChatContext } from '../../../../../../../../Chat.hook.ts';
import { ChatService } from '../../../../../../../../Chat.service.ts';
import {
  tChatLeadsRequest,
  tGetLeadsDataResponse,
} from '../../../../../../../../Chat.types.ts';
import { useMessageBarContext } from '../../../../../../../MessageBar/MessageBar.hook.ts';
import { LLog, LOG_COMPONENTS, LOG_OPERATIONS } from 'src/lib/logging';
import { eChannelType } from 'src/providers/SocketsProvider/Sockets.enums.ts';

export default function useReSendMessageModal() {
  const [loading, setLoading] = useState(false);
  const [leads, setLeads] = useState<tGetLeadsDataResponse[]>([]);
  const { currentWorkspaceId } = useWorkspaceContext();
  const [loadingPetition, setLoadingPetition] = useState(false);
  const { setShowResendModal } = useModalsContext();
  const { setResendIds, selectedChat, selectedChatsIds, setSelectedChatsIds } =
    useChatContext();
  const { setSelectedAction } = useMessageBarContext();
  const { reSendMessage } = useChatActions();

  async function getForwardLeads(query?: string, page: number = 1) {
    try {
      if (!currentWorkspaceId) return;
      setLoading(true);
      const request: tChatLeadsRequest = {
        workspaceId: currentWorkspaceId,
        page: page,
        integration: selectedChat?.integration ?? eChannelType.WHATSAPP_WEB,
      };

      if (query) {
        request.query = query;
      }

      const response = await ChatService.getForwardLeads(request);
      let leads: tGetLeadsDataResponse[] = [];

      if (response.data.leads && response.data.leads.length) {
        leads = response.data.leads.map((lead) => {
          if (lead.chat?.chatId) {
            lead.chatID = lead.chat.chatId;
          }
          return lead;
        });
      }
      setLeads(leads);
      setLoading(false);
    } catch (error) {
      LLog.error(
        {
          component: LOG_COMPONENTS.CHAT,
          method: 'ReSendMessageModal.hook',
          operation: LOG_OPERATIONS.ERROR,
        },
        'Error al reenviar mensaje',
        error as unknown as Error,
      );
    }
  }

  useEffect(() => {
    getForwardLeads();
  }, []);

  async function onReSendMessages() {
    try {
      if (!selectedChat) return;
      setLoadingPetition(true);

      await reSendMessage(selectedChatsIds);

      setResendIds([]);
      setSelectedChatsIds([]);
      setLeads([]);
      setSelectedChatsIds([]);
      setSelectedAction(ChatEnum.CHAT);
      setShowResendModal(false);
    } catch (error) {
      LLog.error(
        {
          component: LOG_COMPONENTS.CHAT,
          method: 'ReSendMessageModal.hook',
          operation: LOG_OPERATIONS.ERROR,
        },
        'Error al reenviar mensaje',
        error as unknown as Error,
      );
    }
  }

  return {
    leads,
    setLeads,
    loading,
    setLoading,
    onReSendMessages,
    loadingPetition,
    setLoadingPetition,
    getForwardLeads,
  };
}
